<template>
  <div>
    <div class="d-flex align-center">
      <div class="text-4">Total Value Locked</div>
      <v-tooltip right max-width="550" color="dark">
        <template v-slot:activator="{ on, attrs }">
          <v-icon x-small class="ml-1 darkgray--text" v-bind="attrs" v-on="on"
            >fas fa-info-circle</v-icon
          >
        </template>
        <div>
          Total value locked in this vault (Vault Balance + Strategy Balance)
        </div>
      </v-tooltip>
    </div>
    <div class="mt-2 primary--text heading-3 font-weight-medium">
      ${{ tvl | numberFormat("0,0") }}
    </div>
    <div class="mt-2 d-flex align-center text-5">
      <span class="gray--text">24h</span>
      <span
        :class="[
          'font-weight-medium ml-1',
          {
            'green--text': change24h.percentage > 0,
            'red--text': change24h.percentage < 0,
            'darkgray--text': change24h.percentage === 0,
          },
        ]"
        ><span></span>
        <span
          ><span v-if="change24h.value < 0">–</span>${{
            change24h.value | abs | numberFormat("0,0")
          }}</span
        >
        <span class="ml-1"
          >(<span v-if="change24h.value < 0">–</span
          ><span v-if="change24h.value > 0">+</span
          ><span
            >{{
              change24h.percentage | abs | numberFormat("0,0.00", false)
            }}%</span
          >)</span
        ></span
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BN from "bignumber.js";

export default {
  props: {
    vaultInfo: Object,
  },
  computed: {
    ...mapGetters({
      vaultsStats: "productStats/vaultsStats",
      getTokenPriceInUsd: "appConfig/getTokenPriceInUsd",
    }),
    vaultStat() {
      return this.vaultsStats.result?.find(
        item =>
          item.vaultType === this.vaultInfo.type &&
          item.token.toLowerCase() === this.vaultInfo.token
      );
    },
    tvl() {
      if (!this.vaultStat) return 0;
      return new BN(this.vaultStat.expectedReturn || 0)
        .multipliedBy(
          this.getTokenPriceInUsd(this.vaultStat.token.toLowerCase())
        )
        .toNumber();
    },
    change24h() {
      if (!this.tvl) {
        return {
          percentage: 0,
          value: 0,
        };
      }
      return {
        value: new BN(this.vaultStat.tvlAfter)
          .minus(this.vaultStat.tvlBefore)
          .multipliedBy(
            this.getTokenPriceInUsd(this.vaultStat.token.toLowerCase())
          )
          .toNumber(),
        percentage: new BN(this.vaultStat.percentChanged)
          .multipliedBy(100)
          .toNumber(),
      };
    },
  },
};
</script>
